<section class="container">
  <div class="header-wrapper">
    <h1>Authentication Providers</h1>
  </div>
  <div class="content-wrapper">
    <div>
      <button [disabled]="isReadOnly"  mat-raised-button class="mat-accent" (click)="addSamlProvider()"><mat-icon>add</mat-icon>Add SAML Authentication Provider</button>
    </div>
    <h3>Current</h3>
    @if (errors.length > 0) {
      <ul class="error-list">
        @for (e of errors; track e) {
          <li>
            <pre>{{e | json}}</pre>
          </li>
        }
      </ul>
    }
    @if (authProviders) {
      <table class="mdl-data-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Admin Only?</th>
            <th>Enabled?</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (provider of authProviders; track provider) {
            <tr>
              <td>{{provider.name}}</td>
              <td>{{getLoginType(provider.loginType)}}</td>
              <td>{{provider.adminOnly}}</td>
              <td>{{provider.isEnabled}}</td>
              <td>
                <a mat-raised-button class="mat-accent tableBtn" (click)="editProvider(provider)">
                  <mat-icon>edit</mat-icon>
                </a>
                @if (provider.loginType > 1 && provider.loginType != 6) {
                  <a mat-raised-button class="mat-warn tableBtn" (click)="deleteProvider(provider)">
                    <mat-icon>delete</mat-icon>
                  </a>
                }
                <a mat-raised-button class="mat-primary tableBtn" (click)="manageLocalisation(provider)">
                  <mat-icon>language</mat-icon>
                </a>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
  @if (managingLocalisation) {
    <div class="content-wrapper">
      <h3>Manage Localisation</h3>
      @if (authProviders) {
        <table class="mdl-data-table">
          <thead>
            <tr>
              <th>Language Code</th>
              <th>Translation</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (translation of translations; track translation) {
              <tr>
                <td>{{translation.languageCode}}</td>
                <td>
                  <input matInput type="text" placeholder="Translation ({{translation.languageCode}})" [(ngModel)]="translation.translation" name="translation-{{translation.languageCode}}" required />
                </td>
                <td>
                  <a mat-raised-button class="mat-primary tableBtn" (click)="updateLocalisation(managingLocalisation, translation.languageCode, translation.translation)">
                    <mat-icon>done</mat-icon>
                  </a>
                </td>
              </tr>
            }
            <tr>
              <td>
                <input matInput type="text" placeholder="Language Code" [(ngModel)]="newLanguageCode" name="new-translation-language-code" required />
              </td>
              <td>
                <input matInput type="text" placeholder="Translation" [(ngModel)]="newTranslation" name="new-translation-text" required />
              </td>
              <td>
                <a mat-raised-button class="mat-primary tableBtn" (click)="updateLocalisation(managingLocalisation, newLanguageCode, newTranslation)">
                  <mat-icon>add</mat-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      }
    </div>
  }
  @if (editingProvider) {
    <div class="content-wrapper">
      <h3>Edit Provider</h3>
      @if (editingProvider) {
        <form (ngSubmit)="saveProvider(editingProvider)" #editProviderForm="ngForm">
          <mat-form-field>
            <mat-label>Provider Name</mat-label>
            <input matInput type="text" [disabled]="isSaving" placeholder="Provider Name" [(ngModel)]="editingProvider.name" name="name" required />
          </mat-form-field>
          @if (editingProvider.loginType === 1) {
            <div>
              <div>
                <mat-form-field>
                  <mat-label>Password Attempts</mat-label>
                  <input matInput type="number" placeholder="Password Attempts" [(ngModel)]="editingProvider.maxPasswordAttempts" name="passAttempts" required />
                </mat-form-field>
              </div>
              <div>
                <mat-form-field>
                  <mat-label>Password Expiry (ticks)</mat-label>
                  <input matInput type="number" placeholder="Password Expiry (ticks)" [(ngModel)]="editingProvider.passwordExpirySpanTicks" name="passExpiry" required />
                </mat-form-field>
              </div>
              <div>
                <mat-checkbox placeholder="Require Recaptcha for Password Reset" [(ngModel)]="editingProvider.requireCaptchaForPasswordReset" name="requireCaptchaForPasswordReset">
                  Require Recaptcha for Password Reset
                </mat-checkbox>
              </div>
              <div>
                <mat-form-field>
                  <mat-label>Minimum complexity regex</mat-label>
                  <input matInput type="text" placeholder="Minimum complexity regex" [(ngModel)]="editingProvider.minumumPasswordRegex" name="minumumPasswordRegex" required />
                </mat-form-field>
              </div>
              <div>
                <mat-form-field>
                  <mat-label>Recommended complexity regex</mat-label>
                  <input matInput type="text" placeholder="Recommended complexity regex" [(ngModel)]="editingProvider.recommendedPasswordRegex" name="recommendedPasswordRegex" required />
                </mat-form-field>
              </div>
            </div>
          }
          @if (editingProvider.loginType === 2) {
            <div>
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>Authentication Flow</mat-label>
                  <mat-select placeholder="SAML Authenticate Type" [(ngModel)]="editingProvider.samlAuthType" name="samlAuthType" required>
                    <mat-option [value]="0">IDP Initiated</mat-option>
                    <mat-option [value]="1">RP Initiated</mat-option>
                  </mat-select>
                  <mat-hint>Typically this is RP (us) initiating. Choose IDP (them) if they want to start the login process</mat-hint>
                </mat-form-field>
              </div>
              <div>
                <mat-checkbox [(ngModel)]="editingProvider.createUserIfDoesntExist" name="createUserIfDoesntExist">
                  Create user on login, if they don't already exist
                </mat-checkbox>
              </div>
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>Login URL</mat-label>
                  <input matInput type="url" placeholder="Redirect URL" [(ngModel)]="editingProvider.redirectUri" name="redirectUri" required />
                  <mat-hint>URL to redirect the user to login</mat-hint>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>Federation Metadata URL</mat-label>
                  <input matInput type="text" placeholder="Federation Metadata URL" [(ngModel)]="editingProvider.fedMetadataUrl" name="fedMetadataUrl" />
                  <mat-hint>URL for fed meta data which contains the certificate etc..</mat-hint>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>Audience/AppId</mat-label>
                  <input matInput type="text" placeholder="Audience Restriction" [(ngModel)]="editingProvider.audienceRestriction" name="audienceRestriction" />
                  <mat-hint>Audience or sometimes called App ID</mat-hint>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>Issuer</mat-label>
                  <input matInput type="text" placeholder="Issuer" [(ngModel)]="editingProvider.issuer" name="issuer" />
                  <mat-hint>Their unique identifier from metadata - don't change this</mat-hint>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>Consumer/Reply URL</mat-label>
                  <input matInput type="url" placeholder="Assertion Consumer URL" [(ngModel)]="editingProvider.assertionConsumerUrl" name="assertionConsumerUrl" />
                  <mat-hint>Consumer or Reply URL, which is our url where their SAML response is sent to</mat-hint>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>Time Skew</mat-label>
                  <input matInput type="number" placeholder="Max Clock Skew (seconds)" [(ngModel)]="editingProvider.maxClockSkew" name="maxClockSkew" required />
                  <mat-hint>Leave this alone, only for Dev purposes</mat-hint>
                </mat-form-field>
              </div>
            </div>
          }
          <div>
            <mat-checkbox [disabled]="isSaving" placeholder="Enabled?" [(ngModel)]="editingProvider.isEnabled" name="isEnabled">
              Enabled?
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox [disabled]="isSaving" placeholder="Admin only?" [(ngModel)]="editingProvider.adminOnly" name="adminOnly">
              Admin only?
            </mat-checkbox>
          </div>
          <button mat-button [disabled]="isSaving" (click)="editingProvider = null">Cancel</button>
          <button mat-raised-button type="submit" class="mat-primary" [disabled]="!editProviderForm.form.valid || isSaving">Submit</button>
        </form>
      }
    </div>
  }
</section>
